//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import _, { isEmpty, isUndefined, isEqual, map, isNull, find } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { initKioskCreationSummaryActionCreators } from '../../store/actions'
import { uriList } from '../../routings/settings/RouteList'
import Button from '../../components/Ui/Buttons'
import Modals from '../../components/Modals'
import Tooltip from '../../components/Tooltip/Tooltip'
import TooltipHelp from '../../components/TooltipHelp/TooltipHelp'
import Table from '../../components/Table'
import ValueCheck from '../../helpers/ValueCheck'
import {
	PageTitle,
	ButtonWrapper,
	TextModal,
	PageWrapperLinks,
	PageWrapperGrids,
	InputWrapper,
	InputLogin,
	LabelText,
	SpanTitle,
	PageWrapperActions,
	PageWrapperActionPrevPage,
} from '../../theme/GlobalCss'
import { LineTableHeader } from '../../components/KioskPerimeter/KioskPerimeter'
import userPrivileges from '../../constants/PrivilegesList'
import Theme from '../../theme/theme'
import allReplace from '../../helpers/allReplace'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const KioskCreationSummaryWrapper = styled.div`
	position: relative;
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-column-gap: 10px;
	& > div:last-child {
		border-right: none;
		padding-right: 0px;
	}
	grid-template-columns: ${(props) => (props.stockRequest ? '1fr 1fr' : '1fr 1fr 50%')};
`
const KioskCreationSummaryColumn = styled.div`
	font-size: ${(props) => props.theme.font.fs};
	border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding-right: 10px;
	height: 100%;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const KioskCreationSummaryTitlePart = styled.span`
	line-height: 32px;
	height: 32px;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	display: block;
	padding-left: 15px;
	font-weight: bold;
	margin-bottom: 10px;
`
const KioskCreationSummaryContentPart = styled.div`
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: auto;
	margin: 10px;
	& input::placeholder {
		font-style: italic;
	}
`
const KioskCreationSummaryStockRequest = styled.div`
	& > div:first-child {
		display: flex;
		align-items: center;
		& > input {
			margin-right: 10px;
		}
	}
`
const SpanTitleWrapper = styled.div`
	padding: 10px 10px 0px 10px;
`
const SpanTitleCustom = styled(SpanTitle)`
	font-weight: normal;
`
const KioskCreationSummaryInfo = styled.div`
	padding: 12px;
	background-color: ${(props) => (props.themed === 'white' ? 'transparent' : props.theme.infoPart.background)};
	border: ${(props) => (props.themed === 'white' ? `1px solid ${props.theme.infoPart.borderBlue}` : 'none')};
	& > div:first-child {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	& > div:first-child span {
		font-weight: bold;
		color: ${(props) => props.theme.colors.primary};
	}
	& > div:first-child img {
		cursor: pointer;
	}
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
const KioskCreationSummaryRacksInfoPart = styled.ul`
	list-style-type: none;
	padding: 0px;
	& > li {
		font-weight: ${(props) => (props.level === 0 ? 'bold' : 'normal')};
	}
	& > li > div {
		display: grid;
		grid-template-columns: 55% 45%;
	}
	& > li > div > span:first-child {
		margin-left: ${(props) => (props.level > 0 ? `${props.level * 30}px` : `0px`)};
	}
	& > li > div > span:nth-child(2) {
		color: ${(props) => (props.level > 0 ? props.theme.text.colors.primary : props.theme.colors.primary)};
	}
`
const KioskCreationSummaryRacksList = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 2px;
`
const KioskCreationSummaryRackItem = styled.div`
	border-radius: 24px;
	background-color: ${(props) => (props.disabled ? props.theme.colors.eraser : props.theme.colors.primary)};
	padding: 13px 21px;
	& > span {
		color: ${(props) => props.theme.colors.white};
	}
	display: grid;
	grid-template-columns: max-content auto max-content;
	grid-column-gap: 15px;
	& > div > img {
		cursor: pointer;
	}
`
//////STYLED//////

const KioskCreationSummary = () => {
	const { translations, userKioskPerimeter, kioskCreation, kioskCreationSummary, userRolePrivileges } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			kioskCreation: state.initKioskCreation,
			kioskCreationSummary: state.initKioskCreation.summary,
			userRolePrivileges: state.user.identity.rolePrivileges,
		}),
		shallowEqual
	)

	const actionsInitKioskCreationSummary = bindActionCreators(initKioskCreationSummaryActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const history = useHistory()
	const match = useRouteMatch()
	const [isUpdate, setIsUpdate] = useState(false)
	const [isEditable, setIsEditable] = useState(false)

	const [stockRequestCheck, setStockRequestCheck] = useState(false)

	const [hasCustomerRight, setHasCustomerRight] = useState(false)
	const [hasBusinessRight, setHasBusinessRight] = useState(false)

	const [showModalConfirmUpdateCustomer, setShowModalConfirmUpdateCustomer] = useState(false)
	const [showModalConfirmUpdateBusiness, setShowModalConfirmUpdateBusiness] = useState(false)
	const [showModalTriggerBuild, setShowModalTriggerBuild] = useState(false)

	const config = {
		//name: '',
		actions: {},
		//fixedColumnSelection: true,
		//autoSize: true,
	}
	const [columnsImplantation, setColumnsImplantation] = useState([])

	const [columnsPrices, setColumnsPrices] = useState([])

	///////////////////////////////// HANDLE ///////////////////////////////////////

	// Actions
	const handleRedirect = () => {
		if (hasCustomerRight) history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)
		if (hasBusinessRight) history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)
	}

	const handleCloseModals = () => {
		if (showModalConfirmUpdateCustomer) setShowModalConfirmUpdateCustomer(false)
		if (showModalConfirmUpdateBusiness) setShowModalConfirmUpdateBusiness(false)
		if (showModalTriggerBuild) setShowModalTriggerBuild(false)
	}

	const handleSubmit = (_data, _e) => {
		if (hasCustomerRight) setShowModalConfirmUpdateCustomer(true)
		if (hasBusinessRight) {
			if (kioskCreation.statusId === 11) {
				setShowModalTriggerBuild(true)
			} else {
				setShowModalConfirmUpdateBusiness(true)
			}
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setColumnsPrices([
			{
				dataHook: 'family',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_familly'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'brand',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_brand'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'itemType',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_type'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'idItem',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_codeItem'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'itemName',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_item'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'standardPrice',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_standardPrice'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.standardPrice) && !isUndefined(props.row.standardPrice)
						? ` ${props.row.standardPrice}${kioskCreationSummary.data?.kioskRequest?.currency?.symbol} `
						: '-',
			},
			{
				dataHook: 'priceHT',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_conversion'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.priceHT) && !isUndefined(props.row.priceHT)
						? `${props.row.priceHT}${kioskCreationSummary.data?.kioskRequest?.currency?.symbol}`
						: '-',
			},
			{
				dataHook: 'standardTVA',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_standardPriceVAT'],
				sortable: true,
				isAuthorize: true,
				component: (props) => `${props.row.standardTVA} %`,
			},
			{
				dataHook: 'depositPrice',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_depositPrice'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.depositPrice) && !isUndefined(props.row.depositPrice)
						? ` ${props.row.depositPrice}${kioskCreationSummary.data?.kioskRequest?.currency?.symbol} `
						: '-',
			},
			{
				dataHook: 'depositTVA',
				headerName: translations['page__initKiosk__kioskCreation_prices_tableHeader_depositPriceVAT'],
				sortable: true,
				isAuthorize: true,
				//component: (props) => `${props.row?.depositTVA} %`,
				component: (props) => ValueCheck.ValueCheck(props.row?.depositTVA, '-', '%'),
			},
		])
	}, [translations, kioskCreationSummary])

	useEffect(() => {
		setColumnsImplantation([
			/* { dataHook: 'id', headerName: '', "isAuthorize": false, component: SalesHistoryToggleNested, sortable: false },*/
			{
				dataHook: 'displayStandLabel',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_displayStandLabel'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'lockerLabel',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerLabel'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'lockerSize',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerFormat'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'lockerState',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerState'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'mustBeEmpty',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_lockerIsHome'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'productImage',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemPicture'],
				sortable: true,
				isAuthorize: true,
				// If product has no image, show '-' because it is a deliberate choice
				component: (props) =>
					!isNull(props.row.productImage) ? (
						<img style={{ maxHeight: '40px', maxWidth: '40px' }} src={`/${props.row.productImage}`} />
					) : (
						'-'
					),
			},
			{
				dataHook: 'idItem',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemCode'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'itemName',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemLabelToDisplay'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'brand',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemBrand'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'itemType',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemType'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'family',
				headerName: translations['page__initKiosk__kioskCreation_growth_tableHeader_itemFamilly'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
		])
	}, [translations, kioskCreationSummary])

	useEffect(() => {
		// Checking what right we got : customer or business view
		if (!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[23]))) setHasCustomerRight(true)
		if (!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[22]))) setHasBusinessRight(true)

		return function cleanUp() {
			actionsInitKioskCreationSummary.resetDataSummary()
		}
	}, [])

	// When customer flag is raised, request
	useEffect(() => {
		if (isEmpty(translations)) return
		if (!isUndefined(match.params.id) && hasCustomerRight && !isUpdate) {
			actionsInitKioskCreationSummary.getSummaryCustomer(match.params.id)
			setIsUpdate(true)
		}
	}, [hasCustomerRight, translations])

	// When business flag is raised, request
	useEffect(() => {
		if (isEmpty(translations)) return
		if (!isUndefined(match.params.id) && hasBusinessRight && !isUpdate) {
			actionsInitKioskCreationSummary.getSummaryBusiness(match.params.id)
			setIsUpdate(true)
		}
	}, [hasBusinessRight, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	// On data loaded
	useEffect(() => {
		if (!isEqual(kioskCreationSummary.data, {}) && isUpdate) {
			setStockRequestCheck(kioskCreationSummary.data.kioskRequest.stock)
			// Disable fields if we are coming from "View" action, or by charging request with URL address
			let editable = true
			if (kioskCreation.forceReadOnly) {
				editable = false
			}
			setIsEditable(editable)
		}
	}, [kioskCreationSummary.data, isUpdate])
	useEffect(() => {
		if (kioskCreation.statusId === 11) {
			setIsEditable(false)
			handleCloseModals()
		}
		if (kioskCreation.statusId === 12 && hasBusinessRight) {
			setIsEditable(false)
			handleCloseModals()
		}
	}, [kioskCreation.statusId])

	useEffect(() => {
		if (kioskCreationSummary.isUpdated) handleRedirect()
	}, [kioskCreationSummary.isUpdated])

	const TableRenderImplantations = useMemo(() => {
		return (
			<Table
				inputColumns={columnsImplantation}
				inputData={!isUndefined(kioskCreationSummary.data.implantations) ? kioskCreationSummary.data.implantations : []}
				inputConfig={config}
				//currentPaging={paging}
				isLoading={kioskCreation.isLoading}
			/>
		)
	}, [kioskCreationSummary, columnsImplantation, config, translations])

	const TableRenderPrix = useMemo(() => {
		return (
			<Table
				inputColumns={columnsPrices}
				inputData={!isUndefined(kioskCreationSummary.data.prices) ? kioskCreationSummary.data.prices : []}
				inputConfig={config}
				//currentPaging={paging}
				isLoading={kioskCreation.isLoading}
			/>
		)
	}, [kioskCreationSummary, columnsImplantation, config, translations])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{/* Customer validation - Finishing config */}
			<Modals
				title={translations['modal__initKiosk__kioskCreation_summary_kioskRequest_title']}
				showModal={showModalConfirmUpdateCustomer}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					{hasCustomerRight && <TextModal>{translations['modal__initKiosk__kioskCreation_summary_kioskRequest_message']}</TextModal>}
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => actionsInitKioskCreationSummary.setSummaryConfigFinishedCustomer(match.params.id)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			{/* Business validation - When he validates for the client to finish config */}
			<Modals
				title={translations['modal__initKiosk__kioskCreation_summary_kioskRequest_title']}
				showModal={showModalConfirmUpdateBusiness}
				closeModalHandler={handleCloseModals}
				//level="info"
				icon={true}
			>
				<TextModalWrapper>
					{hasBusinessRight && !isUndefined(translations['modal__initKiosk__kioskCreation_summary_customerValidation_message']) && (
						<TextModal
							dangerouslySetInnerHTML={{
								__html: _.replace(translations['modal__initKiosk__kioskCreation_summary_customerValidation_message'], '\\n', '<br>'),
							}}
						></TextModal>
					)}
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => actionsInitKioskCreationSummary.setSummaryConfigFinishedBusiness(match.params.id)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			{/* Trigger build */}
			<Modals
				title={translations['modal__initKiosk__kioskCreation_summary_triggerBuild_title']}
				showModal={showModalTriggerBuild}
				closeModalHandler={handleCloseModals}
				icon={true}
			>
				<TextModalWrapper>
					{hasBusinessRight && !isUndefined(translations['modal__initKiosk__kioskCreation_summary_triggerBuild_message']) && (
						<TextModal
							dangerouslySetInnerHTML={{
								__html: allReplace(
									translations['modal__initKiosk__kioskCreation_summary_triggerBuild_message'],
									'\\\\n',
									'<br>'
								) /* translations['modal__initKiosk__kioskCreation_summary_triggerBuild_message'].replaceAll("\\n",'<br>') */,
							}}
						></TextModal>
					)}
				</TextModalWrapper>
				<ButtonWrapper>
					<Button
						actionHandler={handleCloseModals}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => actionsInitKioskCreationSummary.setSummaryTriggerBuild(match.params.id)}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<KioskCreationSummaryWrapper>
				<PageWrapperLinksCustom rafterDisplayed={kioskCreation.statusId >= 6 ? true : false}>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinksCustom>
				<LineTableHeader>
					{hasCustomerRight ? (
						<TooltipHelp content={'tooltip__initKiosk__kioskCreation_summary_anomaly'}>
							<PageTitle>{translations['page__initKiosk__kioskCreation_summary_title']}</PageTitle>
						</TooltipHelp>
					) : (
						<PageTitle>{translations['page__initKiosk__kioskCreation_summary_title']}</PageTitle>
					)}
					<PageWrapperActions>
						{hasBusinessRight && (
							<Button
								weight="bold"
								actionHandler={() => handleSubmit()}
								text={translations['page__initKiosk__kioskCreation_summary_button_triggerBuild']}
								bgColor={Theme.colors.validation}
								img={Validation}
								width={220}
								imgMgin={'16px'}
								noHash
								mgLeft={'5px'}
								disabled={kioskCreation.statusId !== 11}
							/>
						)}
						<Button
							weight="bold"
							actionHandler={() => handleSubmit()}
							text={translations['page__initKiosk__kioskCreation_summary_button_customerValidation']}
							bgColor={Theme.colors.validation}
							img={Validation}
							width={191}
							imgMgin={'16px'}
							noHash
							mgLeft={'5px'}
							disabled={kioskCreation.statusId > 10 || !isEditable}
						/>
						<Tooltip tooltipId={'KioskCreationSummaryCancel'} translationsKey={'tooltip_admin_initKiosk_stepOne_close'}>
							<PageWrapperActionPrevPage
								//onClick={ () => history.push( `${ uriList.initKiosks }${ uriList.initKioskCustomerManager }` ) }
								onClick={() => handleRedirect()}
							/>
						</Tooltip>
					</PageWrapperActions>
				</LineTableHeader>
				<PageWrapperGridsCustom grids={stockRequestCheck ? 2 : 3} stockRequest={stockRequestCheck}>
					<KioskCreationSummaryColumn>
						<KioskCreationSummaryTitlePart>{translations['page__initKiosk__kioskCreation_kiosk_tab']}</KioskCreationSummaryTitlePart>
						<SpanTitleWrapper>
							<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_requestInformation']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							<div>
								<KioskCreationSummaryStockRequest>
									<div>
										<input type="checkbox" name="stockRequest" disabled checked={stockRequestCheck} />
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_isStock']}</LabelText>
									</div>
								</KioskCreationSummaryStockRequest>
							</div>
							{hasBusinessRight && (
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_salesman']} :</LabelText>
									<InputWrapper>
										<InputLogin
											type="text"
											name="salesmen"
											disabled
											placeholder={'NA'}
											value={
												!isNull(kioskCreationSummary.data.businessKioskRequest?.salesmen)
													? kioskCreationSummary.data.businessKioskRequest?.salesmen
													: ''
											}
										/>
									</InputWrapper>
								</div>
							)}
							{stockRequestCheck && (
								<div>
									<LabelText>{translations['page__initKiosk__kioskCreation_summary_quantity']} :</LabelText>
									<InputWrapper>
										<InputLogin
											type="text"
											name="quantity"
											disabled
											placeholder={'NA'}
											value={kioskCreationSummary.data.kioskRequest?.quantity}
										/>
									</InputWrapper>
								</div>
							)}
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_requestName']} :</LabelText>
								<InputWrapper>
									<InputLogin
										type="text"
										name="requestName"
										disabled
										placeholder={'NA'}
										value={kioskCreationSummary.data.kioskRequest?.requestName}
									/>
								</InputWrapper>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_buyoutDate']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="buyoutDate"
										disabled
										type="text"
										placeholder={'NA'}
										value={
											!isNull(kioskCreationSummary.data.businessKioskRequest?.buyoutDate)
												? `${moment(kioskCreationSummary.data.businessKioskRequest?.buyoutDate).format('DD/MM/YYYY')}`
												: ''
										}
									/>
								</InputWrapper>
							</div>
						</KioskCreationSummaryContentPart>
						<SpanTitleWrapper>
							<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_companyInformation']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation_summary_owner']} :</LabelText>
								<InputWrapper>
									<InputLogin
										type="text"
										name="owner"
										disabled
										placeholder={'NA'}
										value={kioskCreationSummary.data.businessCompanyInfos?.owner}
									/>
								</InputWrapper>
							</div>
							{stockRequestCheck && (
								<div>
									<LabelText>{translations['page__initKiosk__kioskCreation_summary_store']} :</LabelText>
									<InputWrapper>
										<InputLogin
											type="text"
											name="store"
											disabled
											placeholder={'NA'}
											value={kioskCreationSummary.data.businessCompanyInfos?.store}
										/>
									</InputWrapper>
								</div>
							)}
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation_summary_distributor']} :</LabelText>
								<InputWrapper>
									<InputLogin
										type="text"
										name="distributor"
										disabled
										placeholder={'NA'}
										value={kioskCreationSummary.data.businessCompanyInfos?.distributor}
									/>
								</InputWrapper>
							</div>
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation_summary_reseller']} :</LabelText>
								<InputWrapper>
									<InputLogin
										type="text"
										name="reseller"
										disabled
										placeholder={'NA'}
										value={kioskCreationSummary.data.businessCompanyInfos?.reseller}
									/>
								</InputWrapper>
							</div>
						</KioskCreationSummaryContentPart>
						{!stockRequestCheck && hasCustomerRight && (
							<Fragment>
								<SpanTitleWrapper>
									<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_contactInformation']}</SpanTitle>
								</SpanTitleWrapper>
								<KioskCreationSummaryContentPart>
									<SpanTitleCustom>{translations['page_admin_initKiosk_stepOne_sheet_storeContactInformation']}</SpanTitleCustom>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_lastname']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactLastName"
												disabled
												type="text"
												placeholder={'NA'}
												value={kioskCreationSummary.data.contactInfos?.lastName}
											/>
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_firstname']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactFirstName"
												disabled
												type="text"
												placeholder={'NA'}
												value={kioskCreationSummary.data.contactInfos?.firstName}
											/>
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_email']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactEmail"
												disabled
												type="text"
												placeholder={'NA'}
												value={kioskCreationSummary.data.contactInfos?.email}
											/>
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_phone']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactPhoneNumber"
												disabled
												type="text"
												placeholder={'NA'}
												value={kioskCreationSummary.data.contactInfos?.phoneNumber}
											/>
										</InputWrapper>
									</div>
								</KioskCreationSummaryContentPart>
							</Fragment>
						)}
						<SpanTitleWrapper>
							<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_kioskInformation']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							{hasBusinessRight && (
								<div>
									<LabelText>{translations['page__initKiosk__kioskCreation_summary_idKiosk']} :</LabelText>
									<InputWrapper>
										<InputLogin
											name="IdKiosk"
											disabled
											type="text"
											placeholder={'NA'}
											value={kioskCreationSummary.data.businessKioskInfos?.idKiosk}
										/>
									</InputWrapper>
								</div>
							)}
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation_summary_kioskModel']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="kioskModel"
										disabled
										type="text"
										placeholder={'NA'}
										value={translations[kioskCreationSummary.data.kioskInfos?.kioskModel]}
									/>
								</InputWrapper>
							</div>
						</KioskCreationSummaryContentPart>
						{!stockRequestCheck && (
							<Fragment>
								<KioskCreationSummaryContentPart>
									<div>
										<LabelText>{translations['page__initKiosk__kioskCreation_summary_kioskDescription']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="kioskLabelToOwner"
												disabled
												type="text"
												placeholder={'NA'}
												value={kioskCreationSummary.data.kioskInfos?.customerKioskCode}
											/>
										</InputWrapper>
									</div>
									{hasBusinessRight && (
										<Fragment>
											<div>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_label']} :</LabelText>
												<InputWrapper>
													<InputLogin
														name="kioskDescription"
														disabled
														type="text"
														placeholder={'NA'}
														value={kioskCreationSummary.data.businessKioskInfos?.kioskDescription}
													/>
												</InputWrapper>
											</div>
											<div>
												<LabelText>{translations['page__initKiosk__kioskCreation_summary_implantationConfig']} :</LabelText>
												<InputWrapper>
													<InputLogin
														name="idDisplayStandImplantation"
														disabled
														type="text"
														placeholder={'NA'}
														value={translations[kioskCreationSummary.data.businessKioskInfos?.implantationType]}
													/>
												</InputWrapper>
											</div>
										</Fragment>
									)}
									<div>
										<LabelText>{translations['page__initKiosk__kioskCreation_summary_installationDate']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="kioskDateInstallation"
												disabled
												type="text"
												placeholder={'NA'}
												value={`${moment(kioskCreationSummary.data.kioskInfos?.installationDateRequested).format(
													'DD/MM/YYYY'
												)}`}
											/>
										</InputWrapper>
									</div>
									{hasBusinessRight && (
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_deliveryDate']} :</LabelText>
											<InputWrapper>
												<InputLogin
													name="kioskDateDelivery"
													disabled
													type="text"
													placeholder={'NA'}
													value={
														!isNull(kioskCreationSummary.data.businessKioskInfos?.deliveryDateScheduled)
															? `${moment(kioskCreationSummary.data.businessKioskInfos?.deliveryDateScheduled).format(
																	'DD/MM/YYYY'
															  )}`
															: null
													}
												/>
											</InputWrapper>
										</div>
									)}
									<div>
										<LabelText>{translations['page__initKiosk__kioskCreation_summary_preferredLanguage']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="kioskLanguage"
												disabled
												type="text"
												placeholder={'NA'}
												value={kioskCreationSummary.data.kioskInfos?.preferredLanguage}
											/>
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_pda']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="pda"
												disabled
												type="text"
												placeholder={'NA'}
												value={translations[kioskCreationSummary.data.kioskInfos?.pda]}
											/>
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_message']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="welcomeMessage"
												disabled
												type="text"
												placeholder={'NA'}
												width={'100%'}
												value={kioskCreationSummary.data.kioskInfos?.welcomeMessage}
											/>
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationType']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="installationType"
												disabled
												type="text"
												placeholder={'NA'}
												value={
													!isNull(kioskCreationSummary.data.kioskInfos?.installationType)
														? translations[kioskCreationSummary.data.kioskInfos?.installationType]
														: ''
												}
											/>
										</InputWrapper>
									</div>
								</KioskCreationSummaryContentPart>
							</Fragment>
						)}
						<KioskCreationSummaryContentPart>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solidDoor']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="solidDoor"
										disabled
										type="text"
										placeholder={'NA'}
										value={translations[kioskCreationSummary.data.kioskInfos?.solidDoor]}
									/>
								</InputWrapper>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_lateralPanel']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="lateralPanel"
										disabled
										type="text"
										placeholder={'NA'}
										value={translations[kioskCreationSummary.data.kioskInfos?.lateralPanel]}
									/>
								</InputWrapper>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_interiorCover']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="interiorCover"
										disabled
										type="text"
										placeholder={'NA'}
										value={translations[kioskCreationSummary.data.kioskInfos?.interiorCover]}
									/>
								</InputWrapper>
							</div>
							<div style={{ display: `${!stockRequestCheck ? 'inherit' : 'none'}` }}>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_restrictedLocation']} :</LabelText>
								<InputWrapper>
									<InputLogin
										name="restrictedLocation"
										disabled
										type="text"
										placeholder={'NA'}
										value={translations[kioskCreationSummary.data.kioskInfos?.restrictedLocation]}
									/>
								</InputWrapper>
							</div>
						</KioskCreationSummaryContentPart>
						<SpanTitleWrapper>
							<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_kioskOption_configuration']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kioskConfigInformation']} :</LabelText>
								<InputLogin
									name="kioskOwnerConfig"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.kioskOptions?.kioskConfig}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_platineSet']} :</LabelText>
								<InputLogin
									name="platineSet"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.platineSet]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_marker']} :</LabelText>
								<InputLogin
									name="marker"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.marker]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleDetaction']} :</LabelText>
								<InputLogin
									name="bottleDetectionAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.bottleDetection]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleMatterSensor']} :</LabelText>
								<InputLogin
									name="bottleMatterSensor"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.matterSensor]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_codePayment']} :</LabelText>
								<InputLogin
									name="codePaymentAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.codePayment]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpa']} :</LabelText>
								<InputLogin
									name="tpaAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.tpa]}
								/>
							</div>
							{kioskCreationSummary.data.kioskOptions?.tpa === 'common__text__yes' && hasBusinessRight && (
								<Fragment>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpaMOdel']} :</LabelText>
										<InputLogin
											name="kioskTpaModel"
											disabled
											type="text"
											placeholder={'NA'}
											value={kioskCreationSummary.data.businessKioskOptions?.tpaModel}
										/>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_integrator']} :</LabelText>
										<InputLogin
											name="kioskTpaIntegrator"
											disabled
											type="text"
											placeholder={'NA'}
											value={kioskCreationSummary.data.businessKioskOptions?.tpaIntegrator}
										/>
									</div>
								</Fragment>
							)}
							{hasBusinessRight && (
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_conectivity']} :</LabelText>
									<InputLogin
										name="kioskConnectivity"
										disabled
										type="text"
										placeholder={'NA'}
										value={kioskCreationSummary.data.businessKioskOptions?.connectivity}
									/>
								</div>
							)}
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_scale']} :</LabelText>
								<InputLogin
									name="scaleAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.scale]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_printer']} :</LabelText>
								<InputLogin
									name="printerAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.printer]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_ticket']} :</LabelText>
								<InputLogin
									name="ticketByMailAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.ticketAvailable]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solar']} :</LabelText>
								<InputLogin
									name="solarPanelAvailable"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.solar]}
								/>
							</div>
							<div>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_barCodeReader']} :</LabelText>
								<InputLogin
									name="barCodeReader"
									disabled
									type="text"
									placeholder={'NA'}
									value={translations[kioskCreationSummary.data.kioskOptions?.barCodeReader]}
								/>
							</div>
						</KioskCreationSummaryContentPart>
						<KioskCreationSummaryContentPart>
							{!isEqual(kioskCreationSummary.data, {}) && (
								<KioskCreationSummaryInfo>
									<div>
										<span>{translations['page_admin_initKiosk_stepOne_sheet_userRequest_fieldsFilled']}</span>
									</div>
									{kioskCreationSummary.data.displayStandInfos?.commercialNote !== null && (
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_salesmenMessage']} :</LabelText>
											<span>{kioskCreationSummary.data.displayStandInfos?.commercialNote}</span>
										</div>
									)}
									{kioskCreationSummary.data.displayStandInfos?.commercialNote === null &&
										!isNull(kioskCreationSummary?.data?.displayStandInfos?.displayStandConfig) &&
										!isNull(kioskCreationSummary?.data?.displayStandInfos?.displayStandConfig?.displayStandTypes) && (
											<div>
												<KioskCreationSummaryRacksInfoPart level={0}>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_rackNumber']} :</span>
															{kioskCreationSummary.data.displayStandInfos?.displayStandConfig.displayStandNumber >
																0 && (
																<span>
																	{
																		kioskCreationSummary.data.displayStandInfos?.displayStandConfig
																			.displayStandNumber
																	}
																</span>
															)}
														</div>
													</li>
													<li>
														<KioskCreationSummaryRacksInfoPart level={1}>
															<li>
																<div>
																	<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseFoldable']} :</span>{' '}
																	<span>
																		{
																			kioskCreationSummary?.data?.displayStandInfos?.displayStandConfig
																				.foldedRacks
																		}
																	</span>
																</div>
																<KioskCreationSummaryRacksInfoPart level={2}>
																	{map(
																		kioskCreationSummary.data?.displayStandInfos?.displayStandConfig
																			.displayStandTypes[1].displayStandModel,
																		(elem) =>
																			elem.displayStandTypeModelNumber > 0 ? (
																				<li>
																					<div>
																						<span>
																							{translations['page_admin_initKiosk_stepOne_sheet_whose']}{' '}
																							{translations[elem.displayStandModel]}
																						</span>{' '}
																						<span>{elem.displayStandTypeModelNumber}</span>
																					</div>
																				</li>
																			) : null
																	)}
																</KioskCreationSummaryRacksInfoPart>
															</li>
															<li>
																<div>
																	<span>
																		{translations['page_admin_initKiosk_stepOne_sheet_whoseUnfoldable']} :
																	</span>{' '}
																	<span>
																		{
																			kioskCreationSummary?.data?.displayStandInfos?.displayStandConfig
																				.unFoldedRacks
																		}
																	</span>
																</div>
																<KioskCreationSummaryRacksInfoPart level={2}>
																	{map(
																		kioskCreationSummary.data.displayStandInfos?.displayStandConfig
																			.displayStandTypes[0].displayStandModel,
																		(elem) =>
																			elem.displayStandTypeModelNumber > 0 ? (
																				<li>
																					<div>
																						<span>
																							{translations['page_admin_initKiosk_stepOne_sheet_whose']}{' '}
																							{translations[elem.displayStandModel]}
																						</span>{' '}
																						<span>{elem.displayStandTypeModelNumber}</span>
																					</div>
																				</li>
																			) : null
																	)}
																</KioskCreationSummaryRacksInfoPart>
															</li>
														</KioskCreationSummaryRacksInfoPart>
													</li>
												</KioskCreationSummaryRacksInfoPart>
												<KioskCreationSummaryRacksInfoPart level={0}>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_lockersNumber']} :</span>
															{kioskCreationSummary.data.displayStandInfos?.displayStandConfig.lockerNumber > 0 && (
																<span>
																	{kioskCreationSummary.data.displayStandInfos?.displayStandConfig.lockerNumber}
																</span>
															)}
														</div>
													</li>
													<KioskCreationSummaryRacksInfoPart level={1}>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']} :</span>
																<span>
																	{
																		kioskCreationSummary.data.displayStandInfos?.displayStandConfig
																			.smallLockerNumber
																	}
																</span>
															</div>
														</li>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_smallBottle_locker']} :</span>
																<span>
																	{
																		kioskCreationSummary.data.displayStandInfos?.displayStandConfig
																			.mediumLockerNumber
																	}
																</span>
															</div>
														</li>
														<li>
															<div>
																<span>
																	{translations['page_admin_initKiosk_stepOne_sheet_mediumBottle_locker']} :
																</span>
																<span>
																	{
																		kioskCreationSummary.data.displayStandInfos?.displayStandConfig
																			.largeLockerNumber
																	}
																</span>
															</div>
														</li>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_largeBottle_locker']} :</span>
																<span>
																	{
																		kioskCreationSummary.data.displayStandInfos?.displayStandConfig
																			.extraLargeLockerNumber
																	}
																</span>
															</div>
														</li>
													</KioskCreationSummaryRacksInfoPart>
												</KioskCreationSummaryRacksInfoPart>
											</div>
										)}
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_productionMessage']} :</LabelText>
										<span>{kioskCreationSummary.data.businessDisplayStandInfos?.productionNote}</span>
									</div>
								</KioskCreationSummaryInfo>
							)}
							{!isEmpty(kioskCreationSummary.data.displayStandInfos?.displayStandName) && (
								<KioskCreationSummaryRacksList>
									{map(kioskCreationSummary.data.displayStandInfos?.displayStandName, (elem) => {
										return (
											<KioskCreationSummaryRackItem disabled>
												<span>{elem}</span>
											</KioskCreationSummaryRackItem>
										)
									})}
								</KioskCreationSummaryRacksList>
							)}
						</KioskCreationSummaryContentPart>
					</KioskCreationSummaryColumn>
					<KioskCreationSummaryColumn>
						<KioskCreationSummaryTitlePart>
							{translations['page__initKiosk__kioskCreation_bankInformations_tab']}
						</KioskCreationSummaryTitlePart>
						<SpanTitleWrapper>
							<SpanTitle>{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_title']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_name']} :</LabelText>
								<InputLogin
									name="bankName"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.name}
								/>
							</div>
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_address']} :</LabelText>
								<InputLogin
									name="bankAdress"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.adress}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_postalCode']} :
								</LabelText>
								<InputLogin
									name="bankPostalCode"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.postalCode}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_city_placeHolder']} :
								</LabelText>
								<InputLogin
									name="bankCity"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.city}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_supportPhone']} :
								</LabelText>
								<InputLogin
									name="bankSupportPhone"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.supportPhone}
								/>
							</div>
						</KioskCreationSummaryContentPart>
						<SpanTitleWrapper>
							<SpanTitle>{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_title']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_customerPo']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithContactCustomerPo"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithContact.customerNumber}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_bankCode']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithContactBankCode"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithContact.bankCode}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_ipAddress']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithContactIpAdress"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithContact.ipAddress}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_padSetting']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithContactPadSetting"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithContact.padSettingNumber}
								/>
							</div>
							<div>
								<LabelText>{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_rank']} :</LabelText>
								<InputLogin
									name="bankAutomateWithContactRank"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithContact.rank}
								/>
							</div>
						</KioskCreationSummaryContentPart>
						<SpanTitleWrapper>
							<SpanTitle>{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_title']}</SpanTitle>
						</SpanTitleWrapper>
						<KioskCreationSummaryContentPart>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_customerPo']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithoutContactCustomerPo"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithoutContact.customerNumber}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_bankCode']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithoutContactBankCode"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithoutContact.bankCode}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_ipAddress']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithoutContactIpAdress"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithoutContact.ipAddress}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_padSetting']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithoutContactPadSetting"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithoutContact.padSettingNumber}
								/>
							</div>
							<div>
								<LabelText>
									{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_rank']} :
								</LabelText>
								<InputLogin
									name="bankAutomateWithoutContactRank"
									disabled
									type="text"
									placeholder={'NA'}
									value={kioskCreationSummary.data.bankInfos?.contractWithoutContact.rank}
								/>
							</div>
						</KioskCreationSummaryContentPart>
					</KioskCreationSummaryColumn>
					{!stockRequestCheck && (
						<KioskCreationSummaryColumn>
							<KioskCreationSummaryTitlePart>{translations['page__initKiosk__kioskCreation_growth_tab']}</KioskCreationSummaryTitlePart>
							{translations && TableRenderImplantations}
							<KioskCreationSummaryTitlePart>{translations['page__initKiosk__kioskCreation_prices_tab']}</KioskCreationSummaryTitlePart>
							{translations && TableRenderPrix}
						</KioskCreationSummaryColumn>
					)}
				</PageWrapperGridsCustom>
			</KioskCreationSummaryWrapper>
		</Fragment>
	)
}

KioskCreationSummary.propTypes = {}

KioskCreationSummary.defaultPropTypes = {}

export default KioskCreationSummary
